
import { isString } from 'lodash'

function retornaCaminhoImagem(nomeIcone){

    if(isString(nomeIcone) && nomeIcone !== ''){
        // if(import.meta.env.PROD){
        //     return `../assets/imgs/${nomeIcone.replace('/', '')}`
        // }
        return `../assets/imgs/${nomeIcone.replace('/', '')}`
    }
    return ''
}

function retornaUrlImagem(nomeIcone){ 
    return new URL(retornaCaminhoImagem(nomeIcone), import.meta.url)
}


const files = {
    retornaUrlImagem
}

export default files;
